import {isNumber} from 'lodash';
import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {Avatar, AvatarProps, avatarSizes} from './avatar';
import {AvatarHover} from './avatarHover';

interface StaticTeammateAvatarProps extends AvatarProps {
  isFaded?: boolean;
  supportsHover?: boolean;
  hasDarkerHover?: boolean;
  avatar16: string;
  avatar30: string;
}

/*
 * Component.
 */

const StaticAvatarBackgroundDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${(p) => p.theme.greys.shade30};
  color: ${(p) => p.theme.greys.shade60};
`;

const StyledImg = styled.img`
  height: 100%;
  width: 100%;
`;

export const StaticTeammateAvatar: FC<PropsWithChildren<StaticTeammateAvatarProps>> = (props) => (
  <Avatar {...props}>
    <StaticAvatarBackgroundDiv>
      <StyledImg src={buildImageUrl(props.size, props.avatar16, props.avatar30)} />
    </StaticAvatarBackgroundDiv>
    {props.supportsHover && <AvatarHover isDarker={props.hasDarkerHover} />}
    {props.children}
  </Avatar>
);

function buildImageUrl(size: VisualSizesEnum | number, avatar16: string, avatar30: string) {
  const sizeNum = isNumber(size) ? size : avatarSizes[size];

  return sizeNum >= avatarSizes[VisualSizesEnum.LARGE] ? avatar30 : avatar16;
}
